import { Autoplay } from 'swiper/modules';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import Slider from '../utils/slider.ts';

class ImageCarousel extends MainClass {
	private sliderInit = new Slider();
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}
	init() {
		if ( window.matchMedia( '(max-width: 600px)' ).matches ) {
			const swiper = this.selector.querySelector( '.swiper-carousel' ) as HTMLElement;
			const gallery = this.selector.querySelector( '.wp-block-gallery' ) as HTMLElement;
			const images = Array.from( gallery.querySelectorAll( 'figure' ) ) as HTMLElement[];
			swiper.classList.add( 'swiper' );
			gallery.classList.add( 'swiper-wrapper' );
			images.forEach( ( image, index ) => {
				image.classList.add( 'swiper-slide' );
			} );

			this.sliderInit.initCarousel( swiper, {
				slidesPerView: 1.2,
				loop: true,
				modules: [ Autoplay ],
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                  },
			} );
		}
	}
}

export default ImageCarousel;
